import { render, staticRenderFns } from "./review-stats.vue?vue&type=template&id=48b4ac20&"
import script from "./review-stats.vue?vue&type=script&lang=js&"
export * from "./review-stats.vue?vue&type=script&lang=js&"
import style0 from "./review-stats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b4ac20')) {
      api.createRecord('48b4ac20', component.options)
    } else {
      api.reload('48b4ac20', component.options)
    }
    module.hot.accept("./review-stats.vue?vue&type=template&id=48b4ac20&", function () {
      api.rerender('48b4ac20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-stats/review-stats.vue"
export default component.exports